export enum PositionsEnum {
  CHIEF_EXECUTIVE_OFFICER = 'chiefExecutiveOfficer',
  CHIEF_FINANCIAL_OFFICER = 'chiefFinancialOfficer',
  CHIEF_OPERATING_OFFICER = 'chiefOperatingOfficer',
  CHIEF_MARKETING_OFFICER = 'chiefMarketingOfficer',
  CHIEF_TECHNOLOGY_OFFICER = 'chiefTechnologyOfficer',
  GENERAL_MANAGER = 'generalManager',
  OPERATIONS_MANAGER = 'operationsManager',
  PROJECT_MANAGER = 'projectManager',
  SALES_MANAGER = 'salesManager',
  STORE_MANAGER = 'storeManager',
  HR_MANAGER = 'hrManager',
  FINANCE_MANAGER = 'financeManager',
  MARKETING_MANAGER = 'marketingManager',
  IT_MANAGER = 'itManager',
  SALES_EXECUTIVE = 'salesExecutive',
  SALES_ADVISOR = 'salesAdvisor',
  CUSTOMER_SERVICE_ADVISOR = 'customerServiceAdvisor',
  CUSTOMER_SERVICE_REPRESENTATIVE = 'customerServiceRepresentative',
  FINANCE_ADVISOR = 'financeAdvisor',
  REAL_ESTATE_AGENT = 'realEstateAgent',
  LEASING_CONSULTANT = 'leasingConsultant',
  PROPERTY_MANAGER = 'propertyManager',
  ADMISSIONS_COUNSELOR = 'admissionsCounselor',
  ACADEMIC_COORDINATOR = 'academicCoordinator',
  TEACHER_ASSISTANT = 'teacherAssistant',
  RETAIL_ASSOCIATE = 'retailAssociate',
  INVENTORY_SPECIALIST = 'inventorySpecialist',
  CASHIER = 'cashier',
  RECEPTIONIST = 'receptionist',
  OFFICE_ASSISTANT = 'officeAssistant',
  MECHANIC_TECHNICIAN = 'mechanicTechnician',
  MOTORCYCLE_SPECIALIST = 'motorcycleSpecialist',
  DELIVERY_DRIVER = 'deliveryDriver',
  WAREHOUSE_WORKER = 'warehouseWorker',
  MARKETING_COORDINATOR = 'marketingCoordinator',
  DIGITAL_MARKETING_MANAGER = 'digitalMarketingManager',
  BUSINESS_DEVELOPMENT_MANAGER = 'businessDevelopmentManager',
  ACCOUNTANT = 'accountant',
  LEGAL_ADVISOR = 'legalAdvisor',
  IT_SUPPORT_SPECIALIST = 'itSupportSpecialist',
  DATA_ENTRY_CLERK = 'dataEntryClerk',
  FRONT_END_DEVELOPER = 'frontEndDeveloper',
  BACK_END_DEVELOPER = 'backEndDeveloper',
  FULL_STACK_DEVELOPER = 'fullStackDeveloper',
  MACHINE_LEARNING_ENGINEER = 'machineLearningEngineer',
  PARTNER = 'partner',
  OTHER = 'other'
}

export type Positions =
| PositionsEnum.CHIEF_EXECUTIVE_OFFICER
| PositionsEnum.CHIEF_FINANCIAL_OFFICER
| PositionsEnum.CHIEF_OPERATING_OFFICER
| PositionsEnum.CHIEF_MARKETING_OFFICER
| PositionsEnum.CHIEF_TECHNOLOGY_OFFICER
| PositionsEnum.GENERAL_MANAGER
| PositionsEnum.OPERATIONS_MANAGER
| PositionsEnum.PROJECT_MANAGER
| PositionsEnum.SALES_MANAGER
| PositionsEnum.STORE_MANAGER
| PositionsEnum.HR_MANAGER
| PositionsEnum.FINANCE_MANAGER
| PositionsEnum.MARKETING_MANAGER
| PositionsEnum.IT_MANAGER
| PositionsEnum.SALES_EXECUTIVE
| PositionsEnum.SALES_ADVISOR
| PositionsEnum.CUSTOMER_SERVICE_ADVISOR
| PositionsEnum.CUSTOMER_SERVICE_REPRESENTATIVE
| PositionsEnum.FINANCE_ADVISOR
| PositionsEnum.REAL_ESTATE_AGENT
| PositionsEnum.LEASING_CONSULTANT
| PositionsEnum.PROPERTY_MANAGER
| PositionsEnum.ADMISSIONS_COUNSELOR
| PositionsEnum.ACADEMIC_COORDINATOR
| PositionsEnum.TEACHER_ASSISTANT
| PositionsEnum.RETAIL_ASSOCIATE
| PositionsEnum.INVENTORY_SPECIALIST
| PositionsEnum.CASHIER
| PositionsEnum.RECEPTIONIST
| PositionsEnum.OFFICE_ASSISTANT
| PositionsEnum.MECHANIC_TECHNICIAN
| PositionsEnum.MOTORCYCLE_SPECIALIST
| PositionsEnum.DELIVERY_DRIVER
| PositionsEnum.WAREHOUSE_WORKER
| PositionsEnum.MARKETING_COORDINATOR
| PositionsEnum.DIGITAL_MARKETING_MANAGER
| PositionsEnum.BUSINESS_DEVELOPMENT_MANAGER
| PositionsEnum.ACCOUNTANT
| PositionsEnum.LEGAL_ADVISOR
| PositionsEnum.IT_SUPPORT_SPECIALIST
| PositionsEnum.DATA_ENTRY_CLERK
| PositionsEnum.FRONT_END_DEVELOPER
| PositionsEnum.BACK_END_DEVELOPER
| PositionsEnum.FULL_STACK_DEVELOPER
| PositionsEnum.MACHINE_LEARNING_ENGINEER
